module.exports = __webpack_public_path__ + "e57649ad19a6b3296babfedeff1de1e3.png";